import { Fragment, useState } from "react";
import { useHistory } from "react-router";
import Button from "core/components/Button";
import Service, { ServiceViewModel } from "entities/service";
import Statement, { StatementViewModel } from "entities/statement";
import { isCurrentMonth } from "core/util/dateUtilities";

interface Props {
    service: ServiceViewModel;
    addNewStatement: (serviceId: number, statement: StatementViewModel) => void;
}

const StatementActions = ({ service, addNewStatement }: Props) => {
    const { id, startDate, statements } = service;
    const history = useHistory();
    const [isGenerating, setIsGenerating] = useState(false);
    const [authorizingStatementId, setAuthorizingStatementId] = useState<number | null>(null);
    const [isGeneratingNC, setIsGeneratingNC] = useState(false);
    const invoiceForCreditNote = statements.find(x => x.isInvoice && x.number && statements.filter(y => y.relatedStatementNumber === x.number).length === 0);
    const reload = () => history.go(0);
    return (
        <Fragment>
            {statements.filter(x => !x.number).map((x) =>
                <div key={x.id} className="mb-1">
                    <Button
                        showSpinner={authorizingStatementId === x.id}
                        label={`Autorizar ${x.statementType}`}
                        type="button"
                        onClick={async () => {
                            setAuthorizingStatementId(x.id);
                            try {
                                await Statement.authorizeStatement(x.id);
                                reload();
                            }
                            catch { setAuthorizingStatementId(null); }
                        }}
                        className="btn-primary"
                    />
                </div>
            )}
            {statements.length % 2 === 0 && isCurrentMonth(startDate) &&
                <Button
                    showSpinner={isGenerating}
                    label="Facturar"
                    type="button"
                    onClick={async () => {
                        setIsGenerating(true);
                        try {
                            const newStatement = await Service.generateInvoice(id);
                            addNewStatement(id, newStatement);
                        }
                        catch { setIsGenerating(false); }
                    }}
                    className="btn-success"
                />}
            {invoiceForCreditNote &&
                <Button
                    showSpinner={isGeneratingNC}
                    label={`Anular #${invoiceForCreditNote.number}`}
                    type="button"
                    onClick={async () => {
                        setIsGeneratingNC(true);
                        try {
                            await Statement.generateCreditNote(invoiceForCreditNote.id);
                            reload();
                        }
                        catch { setIsGeneratingNC(false); }
                    }}
                    className="btn-danger"
                />}
        </Fragment>
    );
};

export default StatementActions;
